<template>
    <n-form v-show="!isFinished" className="form" ref="formRef" :model="formValue" :rules="rules" :size="size">
        <n-form-item path="email">
            <n-input
                v-model:value="formValue.email"
                size="large"
                placeholder="Введите адрес email"
                show-require-mark
                label="test" />
        </n-form-item>
        <n-button size="large" block strong :loading="isLoading" secondary type="success" @click="handleSubmitButton">
            Зарегистрироваться
        </n-button>
    </n-form>
    <n-result
        size="small"
        v-show="isFinished"
        status="success"
        title="Регистрация прошла успешно"
        description="На вашу почту отправлено сообщение с информацией для входа.">
    </n-result>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { signUp } from "@/backend.api";
import identityResult from "@/models/identityResult";
import { useMessage, NInput, NFormItem, NButton, NResult, NForm } from "naive-ui";

const formRef = ref(null) as any;
const message = useMessage();
let isLoading = ref(false);
let isFinished = ref(false);

const size = ref("medium");
const formValue = ref({
    email: ""
});
const rules = {
    email: {
        required: true,
        message: "Пожалуйста введите почту",
        trigger: ["input"],
        type: "email"
    }
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    formRef.value?.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const promise = signUp(formRef.value.model.email);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};
</script>

<style scoped>
.main {
    display: grid;
    place-items: center;
    justify-content: center;
}
</style>
